// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3wiAm","header":"ReportDetails_header__LLCOH","title":"ReportDetails_title__g80RO","left":"ReportDetails_left__a2wGQ"};